import { CommonStatusStep } from './service';
import { DeployArea } from '../config';

export enum DownloadObjectType {
  Client = 1,
  Server = 2,
  Sample = 3,
  Tools = 4,
}

export enum DownloadEngine {
  UEPlugin = 1,
  CPP = 2,
  UnityPlugin = 3,
  Windows = 4,
  WinMsvC = 5,
  Zip = 6,
}

export enum DownloadPlatformType {
  Android = 1,
  IOS = 2,
  Windows = 3,
  Mac = 4,
  PS4 = 5,
  PS5 = 6,
  XSX = 7,
  Switch = 8,
}
export enum IDownLoadType {
  Create = 'create',
  Edit = 'edit',
  White = 'white',
  View = 'view',
}

export interface IEngineItem {
  readonly type: DownloadEngine;
  readonly version: ReadonlyArray<string>; // engine support version
  readonly platform: ReadonlyArray<DownloadPlatformType>;
  readonly package: ReadonlyArray<IEnginePackageItem>;
  readonly gdkVersion: ReadonlyArray<string>;
  readonly pssdkVersion: ReadonlyArray<string>;
  readonly openGDKVersion?: boolean;
  readonly openPSSDKVersion?: boolean;
  readonly key?: string;
}

export interface ISecondEngineItem {
  readonly key?: string;
  readonly ObjectTag: string;
  readonly EngineJson: IEngineItem[];
}
export interface IEnginePackageItem {
  readonly size: number; // kb
  readonly file: string; // xxx/xxx/1.zip, upload save address
  readonly etag: string;
}

// 下载物列表
export interface IDownLoadMenu {
  readonly CreateTime: string;
  readonly CreatorID: number;
  readonly Description: string;
  readonly ModifyTime?: string;
  readonly ModifierID: string;
  readonly Name: string;
  readonly Status: CommonStatusStep;
  readonly Type: DownloadObjectType;
  readonly id: number;
  readonly DocLink: string;
  // readonly Properties?: ReadonlyArray<IEngineItem>;
  readonly VersionItem?: IDownLoadVersionMenu;
  readonly CreatorUserID?: string;
  readonly ModifierUserID: string;
  readonly StudioWhitelist?: ReadonlyArray<string>;
  readonly StudioWhitelistArray?: ReadonlyArray<string>;
  readonly Tag?: string;
  readonly ParentTag?: string | null;
  readonly ParentID?: number | null;
}

// 创建下载物
export interface IDownLoadConfig {
  readonly Description: string;
  readonly Name: string;
  readonly Type: DownloadObjectType;
  readonly Status: CommonStatusStep;
  readonly DocLink: string;
  readonly StudioWhitelist?: ReadonlyArray<string>;
  readonly StudioWhitelistArray?: ReadonlyArray<string>;
  readonly DataSyncID?: string;
}
// 修改下载物
export interface IDownLoadConfigUpdate {
  Description: string;
  Name: string;
  Status: CommonStatusStep;
  DocLink: string;
  StudioWhitelist?: ReadonlyArray<string>;
  StudioWhitelistArray?: ReadonlyArray<string>;
}

// 下载物版本列表
export interface IDownLoadVersionMenu {
  readonly CreateTime: string;
  readonly CreatorID: number;
  readonly DocLink: string;
  readonly Version: string;
  readonly ModifyTime: string;
  readonly ModifierID: number;
  readonly Status: CommonStatusStep;
  readonly EngineJson: ReadonlyArray<IEngineItem>;
  readonly id: number;
  readonly ObjectID: number;
  readonly Description?: string; // 暂无
  readonly SubVersions?: IDownLoadVersionMenu[];
  readonly Tag?: string;
}

// 创建下载物版本
export interface IDownLoadVersionConfig {
  readonly DocLink: string;
  readonly Version: string;
  readonly Status: CommonStatusStep;
  readonly EngineJson: ReadonlyArray<IEngineItem>;
  readonly id?: number;
  readonly ObjectID: number;
  readonly Description?: string; // 暂无
  readonly DataSyncID?: string;
}

// 修改下载物版本
export interface IDownLoadVersionUpdateConfig {
  DocLink: string;
  Status: CommonStatusStep;
  EngineJson: ReadonlyArray<IEngineItem>;
  // id: number;
  Description?: string;
  SubVersions?: ISecondEngineItem[];
}

export enum DownloadSyncEnvType {
  'development' = 'development',
  'test' = 'test',
  'pre-release' = 'pre-release',
  'production' = 'production',
}

export interface IDownloadSyncEnvsArray {
  readonly domainApi: string;
  readonly deployRegion: DeployArea;
  readonly envType: DownloadSyncEnvType;
  readonly needUploadCos: boolean;
}

export interface IDownloadSyncEnvsBody {
  readonly ids: number[];
  readonly syncToEnvs: IDownloadSyncEnvsArray[];
}

export interface IDownloadRecordValue {
  readonly uid: string;
  readonly studioId: string;
  readonly gameName: string;
  readonly envName: string;
  readonly versionID: string;
  readonly subVersionTags: string[];
  readonly engine: Record<string, string>;
}
export interface IDownloadRecordList {
  readonly id: number;
  readonly UniqueKey: string;
  readonly Value: IDownloadRecordValue;
  readonly CreateTime: string;
  readonly CreatorID: string;
}
export interface IDownloadRecord {
  readonly list: IDownloadRecordList[];
  readonly total: number;
  readonly page: number;
  readonly pageSize: number;
}
